import React from 'react';

const IconSubmenu = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" style={{borderBottom: "2px solid white"}} color='white' transform="rotate(90, 8, 8)" width="30" height="30" fill="currentColor" class="bi bi-gender-neuter" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 5a5 5 0 1 1 5.5 4.975V15.5a.5.5 0 0 1-1 0V9.975A5 5 0 0 1 3 5"/>
</svg>
);

export default IconSubmenu;